import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AppService } from "src/app/app.service";
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}

@Component({
  selector: 'app-inclusion-item',
  templateUrl: './inclusion-item.component.html',
  styleUrls: ['./inclusion-item.component.scss']
})
export class InclusionItemComponent implements OnInit {
 
  ContentData: any;
  inclusion_data: any;
  foundnews: any;

  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      const ItemId = params.get("ItemId");
      if (ItemId) {
        this.FetchData(ItemId);
      } else {
        console.log("no ItemId");
      }
    });
  }

  FetchData(ItemId) {
    this.appService.getContents().subscribe((response: any) => {
      console.log(response, "response FetchData");

      this.ContentData = response.data;
      console.log(this.ContentData, "proyash Content Data");

      if (this.ContentData != null) {
        let inclusion = this.ContentData.filter(
          (x) => x.ContentCategoryName == "Inclusion"
        );
        this.inclusion_data = inclusion;

        let newsItem = this.inclusion_data.filter((x) => x.Id == ItemId);
        this.foundnews = newsItem[0];
        console.log(this.inclusion_data, "All News Inclusion Data");
      }
    });
  }
}

